var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "480px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v("统计说明")]
          ),
          _c(
            "div",
            { staticClass: "tip-container" },
            _vm._l(_vm.content, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "tip-li" },
                [
                  _c("div", { staticClass: "li-title" }, [
                    _vm._v(_vm._s(item.title) + " "),
                    item.other
                      ? _c("span", { staticClass: "li-other" }, [
                          _vm._v("(" + _vm._s(item.other) + ")")
                        ])
                      : _vm._e()
                  ]),
                  _vm._l(item.list, function(liItem, liIndex) {
                    return _c(
                      "div",
                      { key: liIndex, staticClass: "li-content" },
                      [
                        _c("div", { staticClass: "content-detail-li" }, [
                          _c("span", { staticClass: "detail-li-title" }, [
                            _vm._v(_vm._s(liItem.title) + ":")
                          ]),
                          _vm._v(_vm._s(liItem.detail) + " ")
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("我知道了")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }